import React from "react";

import FormattedAmount from "pages/_components/FormattedAmount";

import Image from "pages/_components/Image";
import { bool, number, string } from "prop-types";
import { transactionStatus } from "pages/transactions/constants";
import CustomData from "../../_components/CustomData/CustomData";

function getAmountTagClass(status) {
    if (status === transactionStatus.FINISHED) {
        return "amount tag tag-success";
    }
    if (status === transactionStatus.FAILED || status === transactionStatus.CANCELLED) {
        return "amount tag tag-error";
    }
    if (status === transactionStatus.FINISHED_WITH_ERRORS) {
        return "amount tag tag-FINISHED_WITH_ERRORS";
    }
    return "amount tag tag-warning";
}

const EcheqMultipleHeaderTicket = ({ moneda, monto, status, isDesktop }) => (
    <div className={`grid-table-data echeq-header-ticket ${isDesktop ? "desktop" : "mobile"}`}>
        <div className="echeq-logo">
            <Image src="images/logoCompany.svg" />
        </div>

        <div className={`echeq-amount ${isDesktop ? "desktop" : "mobile"}`}>
            <CustomData
                dataClass={`items-center ${getAmountTagClass(status)}`}
                titleText="echeq.transaction.amount.label"
                titleTextType="I18N"
                valueText={<FormattedAmount currency={moneda} quantity={monto} />}
            />
        </div>
         <div className={`echeq-info ${isDesktop ? "desktop" : "mobile"}`}>
        </div>
    </div>
);

EcheqMultipleHeaderTicket.propTypes = {
    moneda: string.isRequired,
    monto: number.isRequired,
    status: string,
    isDesktop: bool.isRequired,
};

EcheqMultipleHeaderTicket.defaultProps = {
    status: "",
};

export default EcheqMultipleHeaderTicket;
